// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609241504/js/" + chunkId + "." + {"44":"3f31a3d6","225":"1098114d","481":"2ad7f36c","486":"11878f4a","770":"40fd355a"}[chunkId] + ".0.7045911310520784.chunk.js";
};